import { render } from "./AlgoliaRefresh.vue?vue&type=template&id=1b8e4497"
import script from "./AlgoliaRefresh.vue?vue&type=script&lang=js"
export * from "./AlgoliaRefresh.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__